exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3YzSfw6jjoux4aBrXdRHlg iframe{width:100%;height:100%}html[dir] ._3YzSfw6jjoux4aBrXdRHlg iframe{border:0}", ""]);
// Exports
exports.locals = {
	"iframeContainer": "_3YzSfw6jjoux4aBrXdRHlg"
};